'use strict';

const styles = theme => ({
    paper: {
		maxWidth: 936,
		margin: 'auto',
		overflow: 'hidden',
	},
	container: {
		padding: '48px 36px 100px',
	},
	fab: {
		position: 'fixed',
		bottom: theme.spacing(4),
		right: theme.spacing(5),
	}
});

export default styles;